import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: ReactNode;
};

/** Renders modal overlay at document.body so it covers sticky app header (z-20). */
export default function ModalPortal({ children }: Props) {
  return createPortal(children, document.body);
}
